export enum PopUpInformalType {
  Info = "info",
  Warning = "warning",
  Error = "error",
  Success = "success",
}
